import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { DbQuestion } from '~src/types/db';
import { QueryKeys } from './queryKeys';
import { getSharedTenderQuestionsList } from '~src/services/api/questions';
import { ResponseWithPagination } from '~src/types/api';

export const useSharedTenderQuestions = (
  params: Parameters<typeof getSharedTenderQuestionsList>[0],
  queryConfig: QueryConfig<ResponseWithPagination<DbQuestion>, AxiosError> = {}
) => {
  const { enabled, ...options } = queryConfig;

  const enabledOverride = enabled || enabled === undefined;

  const filesQuery = useQuery(
    [QueryKeys.sharedTenderQuestion, params],
    () => getSharedTenderQuestionsList(params),
    {
      enabled: enabledOverride,
      ...options,
    }
  );

  return filesQuery;
};
